<template>
  <div class="terminal-layout">
    <div class="terminal-layout__chart">
      <IdiChartSimulator embedded :modules="['desova', 'limits', 'basis']" />
    </div>
    <aside class="terminal-layout__orders">
      <ordersTerminal />
    </aside>
  </div>
</template>

<script>
import ordersTerminal from '@/components/OrdersTerminal.vue'
import IdiChartSimulator from '@/components/IdiChartSimulator.vue'

export default {
  name: 'TerminalView',
  components: { ordersTerminal, IdiChartSimulator },
}
</script>

<style scoped>
.terminal-layout {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  height: calc(100vh - 60px);
  padding: 8px;
  box-sizing: border-box;
}

.terminal-layout__chart {
  flex: 7 1 0;
  min-width: 0;
  min-height: 0;
}

.terminal-layout__orders {
  flex: 3 1 0;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}

.terminal-layout__orders :deep(.orders-terminal) {
  margin-bottom: 0;
  min-height: 100%;
  box-sizing: border-box;
}

.terminal-layout__orders :deep(.ot-grid) {
  grid-template-columns: 1fr;
}

@media (max-width: 1100px) {
  .terminal-layout {
    flex-direction: column;
    height: auto;
    min-height: calc(100vh - 60px);
  }

  .terminal-layout__chart {
    flex: none;
    height: 70vh;
  }

  .terminal-layout__orders {
    flex: none;
    overflow: visible;
  }
}
</style>
